export default "__VITE_ASSET__CiQM4nEU__"